// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__C2CDm","HeaderFixed":"Header_HeaderFixed__KTL4P"};